/*
 * Header de collection sticky (mobile) — reflète l'état du header de site.
 *
 * Le header de site a deux états (basculés par mm-global.js, AVEC hystérésis) :
 *   - "expanded" (haut de page) : barre de recherche en position:absolute SOUS le header
 *     (hors flux) → ~48px de plus sous le header. Classe `.bottom` présente.
 *   - "compact" (scrollé)       : barre de recherche en ligne. Classe `.bottom` absente.
 *
 * On ANCRE la barre en CSS à la hauteur compacte (stable), et on comble l'écart sous
 * le header avec un espace vert foncé (--mm-collection-nav-pad) quand la recherche est
 * dépliée. Bascule INSTANTANÉE (snap, pas de transition → pas de jitter).
 *
 * On se contente de REFLÉTER la classe `.bottom` de la barre de recherche (source de vérité,
 * déjà dotée d'une hystérésis) → parfaitement synchro, et aucun seuil à gérer ici.
 */
(function () {
  var MOBILE = window.matchMedia('(max-width: 768px)');
  var root = document.documentElement;
  var navEl = document.querySelector('.mm-collection-nav-mobile');
  var searchContainer = document.querySelector('.mm-header-search-container');
  var forceCompactSearch = document.body.classList.contains('template-collection');
  if (!navEl) return;

  if (forceCompactSearch && searchContainer) {
    searchContainer.classList.remove('bottom');
  }

  var searchExtra = 48;  // hauteur de la barre de recherche dépliée sous le header
  var state = null;      // 'compact' | 'expanded' | 'off'

  function isSearchExpanded() {
    if (forceCompactSearch) return false;
    return !!(searchContainer && searchContainer.classList.contains('bottom'));
  }

  function apply() {
    var next = !MOBILE.matches ? 'off' : (isSearchExpanded() ? 'expanded' : 'compact');
    if (next === state) return; // une seule écriture par changement d'état
    state = next;

    if (next === 'off') {
      root.style.removeProperty('--mm-collection-nav-pad');
      return;
    }

    // Espace vert foncé qui comble sous le header quand la recherche est dépliée.
    root.style.setProperty('--mm-collection-nav-pad',
      (next === 'expanded' ? searchExtra : 0) + 'px');
  }

  function refresh() { state = null; apply(); }

  apply();

  // La classe `.bottom` est togglée par mm-global.js (avec hystérésis) → on l'observe.
  if (searchContainer && window.MutationObserver) {
    new MutationObserver(apply).observe(searchContainer, {
      attributes: true,
      attributeFilter: ['class']
    });
  }
  window.addEventListener('resize', refresh, { passive: true });
  if (MOBILE.addEventListener) {
    MOBILE.addEventListener('change', refresh);
  } else if (MOBILE.addListener) {
    MOBILE.addListener(refresh);
  }

  var horizontalRails = document.querySelectorAll('.mm-horizontal-fade-rail');

  function updateHorizontalFades(rail) {
    var maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
    rail.classList.toggle('has-scroll-left', rail.scrollLeft > 2);
    rail.classList.toggle('has-scroll-right', rail.scrollLeft < maxScroll - 2);
  }

  horizontalRails.forEach(function (rail) {
    rail.addEventListener('scroll', function () {
      updateHorizontalFades(rail);
    }, { passive: true });
    updateHorizontalFades(rail);
  });

  window.addEventListener('load', function () {
    horizontalRails.forEach(updateHorizontalFades);
  }, { once: true });

  if (window.ResizeObserver && horizontalRails.length) {
    var horizontalRailsResizeObserver = new ResizeObserver(function () {
      horizontalRails.forEach(updateHorizontalFades);
    });
    horizontalRails.forEach(function (rail) {
      horizontalRailsResizeObserver.observe(rail);
    });
  }

  var CONTEXT_KEY = 'mmCollectionBreadcrumbContext';

  function getText(node) {
    return node ? node.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function getCurrentBreadcrumbContext(destinationLink) {
    var crumbs = document.querySelector('[data-mm-collection-crumbs]');
    var currentCrumb = document.querySelector('[data-mm-current-crumb]');
    if (!currentCrumb) return null;

    var items = [];
    if (crumbs) {
      crumbs.querySelectorAll('[data-mm-crumb-handle]').forEach(function (crumb) {
        var handle = crumb.getAttribute('data-mm-crumb-handle');
        var title = crumb.getAttribute('data-mm-crumb-title') || getText(crumb);
        var url = crumb.getAttribute('data-mm-crumb-url') || crumb.getAttribute('href');
        if (handle && title) {
          items.push({ handle: handle, title: title, url: url });
        }
      });
    } else {
      items.push({
        handle: currentCrumb.getAttribute('data-mm-crumb-handle'),
        title: currentCrumb.getAttribute('data-mm-crumb-title') || getText(currentCrumb),
        url: currentCrumb.getAttribute('data-mm-crumb-url')
      });
    }

    var destinationHandle = destinationLink.getAttribute('data-mm-context-destination-handle');
    var destinationTitle = destinationLink.getAttribute('data-mm-context-destination-title') || getText(destinationLink);
    if (!destinationHandle || !destinationTitle || !items.length) return null;

    var isPeerNavigation = destinationLink.getAttribute('data-mm-context-navigation') === 'peer';
    var peerRail = isPeerNavigation ? destinationLink.closest('[data-mm-chip-mode="peer"]') : null;
    if (isPeerNavigation) {
      items.pop();
    }
    items.push({ handle: destinationHandle, title: destinationTitle, url: destinationLink.getAttribute('href') });
    return {
      destinationHandle: destinationHandle,
      items: items,
      peerScrollLeft: peerRail ? peerRail.scrollLeft : null,
      createdAt: Date.now()
    };
  }

  function storeBreadcrumbContext(link) {
    if (!window.sessionStorage) return;
    var context = getCurrentBreadcrumbContext(link);
    if (!context) return;

    try {
      window.sessionStorage.setItem(CONTEXT_KEY, JSON.stringify(context));
    } catch (error) {}
  }

  document.addEventListener('click', function (event) {
    var contextLink = event.target.closest('[data-mm-context-destination-handle]');
    if (contextLink) {
      storeBreadcrumbContext(contextLink);
    }
  });

  // Bottom sheet de navigation laterale (soeurs du niveau courant).
  var sheets = document.querySelectorAll('[data-mm-rayons-sheet]');
  if (sheets.length) {
    // On deplace les sheets en fin de <body> pour que leur position:fixed + z-index
    // passent au-dessus du header sticky et du contenu, hors du contexte d'empilement
    // de la section collection.
    sheets.forEach(function (sheet) {
      if (document.body && sheet.parentNode !== document.body) {
        document.body.appendChild(sheet);
      }
    });

    var setSheet = function (sheetId, open) {
      sheets.forEach(function (sheet) {
        sheet.classList.toggle('is-open', open && sheet.id === sheetId);
      });
      document.documentElement.classList.toggle('stop-scrolling', open);
      document.querySelectorAll('[data-mm-sheet-open]').forEach(function (button) {
        button.setAttribute('aria-expanded', open && button.getAttribute('data-mm-sheet-open') === sheetId ? 'true' : 'false');
      });
    };

    document.addEventListener('click', function (event) {
      var openButton = event.target.closest('[data-mm-sheet-open]');
      if (openButton) {
        event.preventDefault();
        setSheet(openButton.getAttribute('data-mm-sheet-open'), true);
        return;
      }
      if (event.target.closest('[data-mm-rayons-close]')) {
        event.preventDefault();
        setSheet(null, false);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && document.querySelector('.mm-rayons-sheet.is-open')) {
        setSheet(null, false);
      }
    });
  }

  var crumbs = document.querySelector('[data-mm-collection-crumbs]');
  var currentCrumb = document.querySelector('[data-mm-current-crumb]');
  if (crumbs && currentCrumb) {
    function positionCrumbs() {
      var directParent = currentCrumb.previousElementSibling ? currentCrumb.previousElementSibling.previousElementSibling : null;
      var target = directParent || currentCrumb;
      var left = target.offsetLeft + target.offsetWidth - crumbs.clientWidth + currentCrumb.offsetWidth;
      crumbs.scrollLeft = Math.max(0, left);
      crumbs.classList.add('is-positioned');
    }

    if (!crumbs.classList.contains('is-positioned')) {
      positionCrumbs();
    }
    window.addEventListener('load', positionCrumbs, { once: true });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(positionCrumbs);
    }
  }
})();
